module.exports = __webpack_public_path__ + "91242e97f8f06edcfb9a048a3059a2da.svg";